import { Navigate } from 'react-router-dom';
import { useTenant } from '../components/TenantContext.jsx';

/**
 * 擋經銷商 (accountRole=dealer) 的 route 守衛 —— dealer 即使 deep-link 也導回首頁。
 * 用於「方案總覽 /plans」等不該讓經銷商看到的頁。
 * nav 隱藏 (Layout dealerHidden) 只是 UX；這層才真正擋住直接打 URL。
 */
export function RequireNotDealer({ children }) {
    const { accountRole, loading } = useTenant();
    if (loading) {
        return (
            <div className="grid min-h-dvh place-items-center text-ink-500">
                <div className="font-mono text-sm">Loading…</div>
            </div>
        );
    }
    if (accountRole === 'dealer') return <Navigate to="/" replace />;
    return children;
}
